/* eslint-disable toplevel/no-toplevel-side-effect */
/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable no-loops/no-loops */
/**
 * Integration des JW Player bei heise online
 * Seit 12/2017: Integration des Kaltura-Player in JW Markup
 *
 * @author Stephen Fischer
 * @author Sebastian Hilbig
 */
'use strict'

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity
const HeiseVideo = function(element) {
  /*
   * HELPER-FUNCTIONS
   *
   * kudos to https://stackoverflow.com/a/20584396
   */

  /*
   * Den uebergebenen node rekursiv nach <script>s durchsuchen und dann durch
   * ausfuehrbare <script>-nodes ersetzen
   */
  function nodeScriptReplace(node) {
    if (nodeScriptIs(node) === true) {
      node.parentNode.replaceChild(nodeScriptClone(node), node)
    } else {
      let i = 0
      const children = node.childNodes

      while (i < children.length) {
        nodeScriptReplace(children[i++])
      }
    }

    return node
  }

  // Ist der uebergebene node ein <script>?
  function nodeScriptIs(node) {
    return node.tagName === 'SCRIPT'
  }

  /*
   * Den uebergebenen node 1:1 als ausfuehrbares <script> kopieren und
   * zurueckgeben
   */
  function nodeScriptClone(node) {
    const script = document.createElement('script')
    script.text = node.innerHTML

    for (let i = node.attributes.length - 1; i >= 0; i--) {
      script.setAttribute(node.attributes[i].name, node.attributes[i].value)
    }

    return script
  }

  // Helper, weil nicht alle Browser .classList.contains() koennen
  function hasClass(target) {
    return target.className.match(/\bplayer\b/)
  }

  /*
   * Container- und Sequenz-ID oder Kaltura-ID aus den Data-Attributen holen, um
   * sie an die API weiter zu reichen.
   * Außerdem Titel und die Params-Variable.
   */
  const vidKaltura = element.getAttribute('data-kaltura-id')
  const vidCon = element.getAttribute('data-container')
  const vidSeq = element.getAttribute('data-sequenz')
  const vidTitle = element.getAttribute('data-title')
  const vidSubTitle = element.getAttribute('data-subtitle')
  const vidSource = element.getAttribute('data-source')
  let params

  if (vidKaltura !== null && vidKaltura.length !== 0) {
    // Haben wir eine Kaltura-Id, verwenden wir die.
    params = `kaltura_id=${vidKaltura}`
  } else if (
    vidCon !== null &&
    vidSeq !== null &&
    vidCon.length !== 0 &&
    vidSeq.length !== 0
  ) {
    // Ansonsten verwenden wir Container- und Sequenz-Id
    params = `container=${vidCon}&sequenz=${vidSeq}`
  } else {
    // Sind die Attribute nicht vorhanden brechen wir ab und werfen einen Fehler
    console.error(
      `Weder Kaltura-ID noch Container- und Sequenz-ID vorhanden am Element: ${element}`
    )
    return
  }

  if (vidTitle !== null && vidTitle.length > 0) {
    params += `&title=${encodeURIComponent(vidTitle)}`
  }
  if (vidSubTitle !== null && vidSubTitle.length > 0) {
    params += `&subtitle=${encodeURIComponent(vidSubTitle)}`
  }
  if (vidSource !== null && vidSource.length > 0) {
    params += `&source=${encodeURIComponent(vidSource)}`
  }

  /*
   * Der XHR-Request wird aufgebaut. Obacht: ".open" startet den Request nicht,
   * das tut erst ".send" weiter unten.
   * Der dritte Parameter mit dem Wert "true" ist dafuer da um sicherzustellen,
   * dass der Request async ausgeführt wird.
   */
  const request = new window.XMLHttpRequest()
  request.open('POST', '/multimediadatei/', true)

  // Korrekten Content-Type fuer POST-Requests setzen
  request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')

  // Erfolgs- und Fehlerfall des Requests werden definiert
  request.addEventListener('load', function() {
    if (request.status === 200) {
      /*
       * Das Ergebnis des Requests wird in das aktuelle DOM-Element geschrieben
       * und anschließend von der Helper-Function nodeScripteReplace() so
       * bearbeitet, dass die darin befindlichen <script>s auch ausführbar sind.
       */
      const resp = request.responseText

      /*
       * Wenn unser element-Node (.videoplayerjw) ein direktes Kind-Element von
       * einem figure.player ist, dann wollen wir das Kaltura-Player-HTML statt
       * des figure.player einsetzen. Ansonsten setzen wir das HTML einfach
       * in den element-Node.
       */
      if (
        hasClass(element.parentNode) &&
        element.parentNode.tagName === 'FIGURE'
      ) {
        const responseContainer = document.createElement('div')
        const oldFigure = element.parentNode

        responseContainer.innerHTML = resp
        oldFigure.replaceWith(responseContainer)
        nodeScriptReplace(responseContainer)
      } else {
        element.innerHTML = resp
        nodeScriptReplace(element)
      }
    } else {
      console.error('Falsche Serverantwort bekommen.')
    }
  })

  // Es wird ein Fehler ausgegeben, falls der Request gar nicht zustande kommt
  request.addEventListener('error', function() {
    console.error('Ziel anscheinend nicht erreichbar.')
  })

  // Der XHR-Request wird abgesendet
  request.send(params)
}

export default HeiseVideo

// Die Videoplayer werden in einem Array gesammelt
const videoArr = document.querySelectorAll('.videoplayerjw')

// Für alle Nodes wird HeiseVideo() aufgerufen
Array.prototype.forEach.call(videoArr, function(element) {
  element.video = new HeiseVideo(element)
})
